import { render, staticRenderFns } from "./ShowEconomicGroup.vue?vue&type=template&id=f2bda558"
import script from "./ShowEconomicGroup.vue?vue&type=script&lang=js"
export * from "./ShowEconomicGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports